'use strict';

var PersonOutline = require('../../../_virtual/PersonOutline.js_commonjs-exports.js');
var interopRequireDefault = require('../../@babel/runtime/helpers/interopRequireDefault.js');
var React = require('react');
require('./utils/createSvgIcon.js');
var createSvgIcon = require('../../../_virtual/createSvgIcon.js_commonjs-exports.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _interopRequireDefault = interopRequireDefault;

Object.defineProperty(PersonOutline.__exports, "__esModule", {
  value: true
});
exports["default"] = PersonOutline.__exports.default = void 0;

var _react = _interopRequireDefault(React__default["default"]);

var _createSvgIcon = _interopRequireDefault(createSvgIcon.__exports);

var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
  d: "M12 5.9c1.16 0 2.1.94 2.1 2.1s-.94 2.1-2.1 2.1S9.9 9.16 9.9 8s.94-2.1 2.1-2.1m0 9c2.97 0 6.1 1.46 6.1 2.1v1.1H5.9V17c0-.64 3.13-2.1 6.1-2.1M12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z"
}), 'PersonOutline');

exports["default"] = PersonOutline.__exports.default = _default;

module.exports = exports["default"];
